import { observer } from "mobx-react";
import { useEffect } from "react";

import { ButtonWithIcon } from "components/UI/ButtonWithIcon/ButtonWithIcon";

import "./AiAgentSelection.scss";

const AiAgentSelection = observer(({ store, market }) => {
  const { selectedAiAgent } = store;
  const aiAgents = market.aiAgents || [];

  useEffect(() => {
    // Auto-select first agent if none selected
    if (!selectedAiAgent && aiAgents.length > 0) {
      store.setSelectedAiAgent(aiAgents[0]);
    }
  }, [selectedAiAgent, aiAgents, store]);

  if (!aiAgents.length) {
    return null;
  }

  const handleSelectAgent = (agent) => {
    store.setSelectedAiAgent(agent);
  };

  return (
    <div className="ai-agent-selection">
      <p className="ai-agent-selection__title">Выберите AI-агента:</p>
      <div className="ai-agent-selection__container">
        {aiAgents.map((agent, i) => (
          <div key={agent.id} className="ai-agent-selection__wrapper">
            <ButtonWithIcon
              title={
                <div className="ai-agent-selection__agent-title">
                  <h4>{agent.title}</h4>
                  <p>{agent.description}</p>
                </div>
              }
              className={`ai-agent-selection__button ${selectedAiAgent?.id === agent.id ? "active" : ""}`}
              onClick={() => handleSelectAgent(agent)}
              ariaLabel={`Выбрать ${agent.title}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
});

export default AiAgentSelection;
